import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Früher habe ich jeden Sonntag drei bis vier Stunden mit der Wochenplanung verbracht. Mit dem Class Builder System™ baue ich meine Gruppenkurse jetzt in unter 15 Minuten auf – und sie sind besser strukturiert als je zuvor. Meine Teilnehmer merken den Unterschied sofort.',
  author: 'Tobias Reinhardt',
  role: 'Functional Trainer & Studio-Inhaber',
  location: 'Frankfurt, Deutschland',
  age: 38
}, {
  text: 'Die Movement Library™ allein ist das Geld zehnfach wert. Endlich habe ich für jede Übung Progressionen, Regressionen und Coaching Cues an einem Ort. Ich wirke vor meinen Kunden viel sicherer und kompetenter.',
  author: 'Sandra Brinkmann',
  role: 'Personal Trainerin',
  location: 'Köln, Deutschland',
  age: 34
}, {
  text: 'Als Studio-Inhaber mit 5 Trainern hat dieses System unsere Kursqualität standardisiert. Die Progression Programs™ und Coaching Tools™ geben jedem im Team die gleiche professionelle Grundlage. Wir haben unsere Kundenbindung spürbar verbessert.',
  author: 'Markus Hoffmann',
  role: 'Inhaber Functional Studio',
  location: 'Stuttgart, Deutschland',
  age: 45
}, {
  text: 'Ich bin frisch zertifiziert und war anfangs unsicher, wie ich Einheiten richtig aufbaue. Die Functional Foundations™ und das Coaching Cues Cheat Sheet™ haben mir vom ersten Tag an Struktur und Sicherheit gegeben. Unbezahlbar für den Einstieg.',
  author: 'Laura Schäfer',
  role: 'Functional Trainerin',
  location: 'München, Deutschland',
  age: 27
}, {
  text: 'Der 7-Day Planning Sprint™ hat meine Arbeitsweise komplett verändert. Ich plane jetzt meine ganze Woche in einer einzigen 30-Minuten-Session und habe meine Wochenenden zurück. Genau das System, das ich vor Jahren gebraucht hätte.',
  author: 'Daniel Wagner',
  role: 'Personal Trainer & Online-Coach',
  location: 'Hamburg, Deutschland',
  age: 41
}];
export function Testimonials() {
  return <section className="py-10 px-4 bg-white border-y border-brand-gold/30" data-id="element-147">
      <div className="max-w-4xl mx-auto" data-id="element-148">
        <div className="text-center mb-5" data-id="element-149">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite mb-1" data-id="element-150">
            WAS TRAINER ÜBER DAS SYSTEM SAGEN
          </h2>
          <p className="text-base text-brand-graphite/70" data-id="element-151">
            Bewertungen von Fachleuten
          </p>
        </div>

        <div className="space-y-4" data-id="element-152">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-cream border-2 border-brand-gold/40 p-5 rounded-lg" data-id="element-153">
              <div className="flex gap-1 mb-3" data-id="element-154">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-155" />)}
              </div>
              <p className="text-brand-graphite mb-4 leading-relaxed italic" data-id="element-156">
                "{t.text}"
              </p>
              <div className="border-t border-brand-gold/30 pt-4 flex items-center gap-4" data-id="element-157">
                <div className="w-12 h-12 rounded-full bg-brand-petrol/10 flex items-center justify-center text-brand-petrol font-bold text-lg" data-id="element-158">
                  {t.author.charAt(0)}
                </div>
                <div data-id="element-159">
                  <p className="font-bold text-brand-graphite" data-id="element-160">
                    {t.author}, {t.age}
                  </p>
                  <p className="text-sm text-brand-graphite/70" data-id="element-161">
                    {t.role} — {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}